import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductSku extends HTMLElement {
  connectedCallback() {
    this.closest('.shopify-section, dialog')
      ?.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    this.closest('.shopify-section, dialog')
      ?.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  updateSku = (event) => {
    const newSku = event.detail.data.html.querySelector('product-sku');
    if (!newSku) return;

    morph(this, newSku, { childrenOnly: true });
  };
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}